<template>
	<b-container class="p-4">
		<b-form @submit.prevent="handleSubmit">
			<b-form-group :label="FormMSG(200, 'Prefix:')" label-for="prefix-input" :label-cols="3">
				<b-form-input id="prefix-input" v-model="newDep.prefix" type="text" :disabled="isFormDisabled" />
			</b-form-group>

			<b-form-group :label="FormMSG(2, 'Department:')" label-for="department-name-input" :label-cols="3">
				<b-form-input id="department-name-input" v-model="newDep.message" type="text" :disabled="isFormDisabled" />
			</b-form-group>

			<b-form-group :label="FormMSG(100, 'Category')" label-for="category-select" :label-cols="3">
				<treeselect id="category-select" v-model="newDep.categoryLinkedToDep" :multiple="false" :options="categorieList" :disabled="isFormDisabled" />
			</b-form-group>

			<b-form-group :label="FormMSG(9, 'Reference')" label-for="cost-center-input" :label-cols="3">
				<b-form-input id="cost-center-input" v-model="newDep.costCenter" type="text" :disabled="isFormDisabled" />
			</b-form-group>

			<div class="d-flex justify-content-end">
				<b-button type="submit" variant="primary" :disabled="isFormDisabled"> Save Department </b-button>
			</div>
		</b-form>
	</b-container>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import { getBudgetHierarchicalCategoryJson } from '../../cruds/budget.crud';
import { updateDepartment, deleteDepartment, addDepartment, getDepartments } from '@/cruds/department.crud';
import { removeAttributeTree } from '../../shared/utils';
import globalMixin from '@/mixins/global.mixin';

export default {
	name: 'DepartmentForm',

	components: {
		Treeselect
	},

	mixins: [globalMixin],

	data() {
		return {
			newDep: {
				value: 0,
				prefix: '',
				message: '',
				categoryLinkedToDep: null,
				costCenter: ''
			},
			categorieList: [],
			hasCreated: false
		};
	},

	computed: {
		isFormDisabled() {
			return this.newDep.value === 0;
		}
	},

	methods: {
		handleSubmit() {
			updateDepartment(+this.newDep.id, this.newDep.message, this.newDep.costCenter, this.newDep.prefix, this.newDep.categoryLinkedToDep)
				.then((result) => {
					this.showSuccessToast();
					this.newDep = result.UpdDepartment;
					this.$emit('department-form:department-updated', this.newDep);
				})
				.catch((error) => {
					this.showSuccessToast();
				});
		},
		newDepartment() {
			addDepartment()
				.then((result) => {
					this.reloadData();
					this.newDep = result.NewDepartment;
					this.$emit('department-form:department-created', this.newDep);
				})
				.catch((error) => {
					console.log(error);
					this.erreur = error;
				});
		},
		async reloadData() {
			await this.loadDepartments();
			await this.loadCategories();
		},
		loadDepartments() {
			return getDepartments()
				.then((result) => {
					this.Deps = result;
				})
				.catch((error) => {
					console.log(error);
					this.erreur = error;
				});
		},
		async loadCategories() {
			try {
				const response = await getBudgetHierarchicalCategoryJson(-2);
				const processedTree = this.processCategoryTree(response);

				this.categorieList = [
					{
						id: -1,
						label: this.FormMSG(76, 'Select a category')
					},
					...processedTree
				];
			} catch (error) {
				console.error('Error loading categories:', error);
			}
		},
		processCategoryTree(tree) {
			const updateTree = (nodes) => {
				return nodes
					.map((node) => {
						const newNode = { ...node };

						// Disable nodes that are linked to departments
						if (newNode.data.linkedToDepId !== 0) {
							delete newNode.children;
							newNode.isDisabled = true;
						}

						// Process nodes with categories
						if (newNode.data.category !== 0) {
							if (newNode.children && newNode.children.length > 0) {
								newNode.children = updateTree(newNode.children);
							}
							return newNode;
						}
					})
					.filter((node) => node !== undefined);
			};

			const cleanedTree = removeAttributeTree(tree, 'children', null);
			return updateTree(cleanedTree);
		},
		showSuccessToast() {
			this.createToastForMobile(this.FormMSG(154, 'Department updated successfully'), '', '', 'success', this.FormMSG(155, 'Success'));
		}
	},

	mounted() {
		if (!this.hasCreated) {
			this.newDepartment();
			this.hasCreated = true;
		}
	}
};
</script>

<style scoped>
/* Optional styling */
</style>
